import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Chip,
  Box,
  useTheme
} from '@mui/material';
import TaskIcon from '@mui/icons-material/Task';
import { useAgent } from '../contexts/AgentContext';

interface Task {
  id: string;
  type: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  description: string;
  timestamp: Date;
}

const AgentTaskList: React.FC = () => {
  const theme = useTheme();
  useAgent();

  // This will be replaced with actual tasks from the agent state
  const tasks: Task[] = [
    {
      id: '1',
      type: 'CLIENT_QUERY',
      status: 'completed',
      description: 'Search for client records',
      timestamp: new Date()
    },
    {
      id: '2',
      type: 'SESSION_SCHEDULING',
      status: 'processing',
      description: 'Schedule counselling session',
      timestamp: new Date()
    }
  ];

  const getStatusColor = (status: Task['status']) => {
    switch (status) {
      case 'completed':
        return theme.palette.success.main;
      case 'processing':
        return theme.palette.info.main;
      case 'failed':
        return theme.palette.error.main;
      default:
        return theme.palette.warning.main;
    }
  };

  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {tasks.length === 0 ? (
        <Typography variant="body2" color="textSecondary" sx={{ p: 2 }}>
          No tasks yet
        </Typography>
      ) : (
        tasks.map((task) => (
          <ListItem
            key={task.id}
            sx={{
              mb: 1,
              borderRadius: 1,
              border: `1px solid ${theme.palette.divider}`,
              '&:hover': {
                backgroundColor: theme.palette.action.hover
              }
            }}
          >
            <ListItemIcon>
              <TaskIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body1" component="span">
                    {task.description}
                  </Typography>
                  <Chip
                    label={task.status}
                    size="small"
                    sx={{
                      backgroundColor: getStatusColor(task.status),
                      color: '#fff'
                    }}
                  />
                </Box>
              }
              secondary={
                <Typography variant="caption" color="textSecondary">
                  {new Date(task.timestamp).toLocaleString()}
                </Typography>
              }
            />
          </ListItem>
        ))
      )}
    </List>
  );
};

export default AgentTaskList;
